import React from "react";
import ScopeSequenceEditorContent from "./ScopeSequenceEditorContent";

function ScopeSequenceTab({ courseId }) {
  return (
    <div className="curriculum-scope-tab">
      <ScopeSequenceEditorContent courseId={courseId} />
    </div>
  );
}

export default ScopeSequenceTab;
